
$(function () {
    $("[stems-ajax]").each(function (idx, element) {
        var url = $(this).data("url");
        var container = $(this).data("container");

        if (url) {
            $(function () {
                $.ajax({
                    url: url,
                    method: "GET",
                    dataType: "html",
                    success: function (d) {
                        $("#" + container).html(d);
                    },
                    error: function (x, s, e) {}
                });
            });
        }
    });
})